import React, {useRef, useState} from 'react';
import View from './view';
import {KidSubformFieldProps} from './model';
import {change} from 'redux-form';
import {Forms} from '../../../../../../../shared/models/forms';

import {useAppDispatch} from '../../../../../../../redux';

export const KidSubformField = (props: KidSubformFieldProps) => {
  const dispatch = useAppDispatch();
  const prevValue = useRef(props.value);
  const [isChanging, setIsChanging] = useState(props.isChanging ?? false);

  const onTurnChanging = () => {
    if (!props.editable) return;
    prevValue.current = props.value;
    setIsChanging(true);
  };

  const onAccept = () => {
    setIsChanging(() => {
      props.setSubmissionErrors((prev: any) => ({...prev, [props.name]: null}));
      return false;
    });
  };

  const onDecline = () => {
    dispatch(change(`${Forms.kidSubform}-${props.kidId}`, props.name, prevValue.current));
    setIsChanging(false);
  };

  return (
    <View
      {...props}
      isChanging={isChanging}
      onTurnChanging={onTurnChanging}
      onDecline={onDecline}
      onAccept={onAccept}
    />
  );
};
